import { Phone } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { BUSINESS, IMAGES } from "@/data/site";
import { WhatsAppIcon } from "@/components/Icons";

export default function HomeCTA() {
  const { t } = useLanguage();
  return (
    <section className="relative overflow-hidden py-28 md:py-36">
      <img
        src={IMAGES.darkCup}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-obsidian via-obsidian/80 to-obsidian" />

      <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-10">
        <Reveal>
          <Eyebrow className="justify-center">{t.homeCta.eyebrow}</Eyebrow>
          <h2 className="mx-auto mt-6 max-w-2xl font-serif text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl">
            {t.homeCta.heading}
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-cream/65">
            {t.homeCta.body}
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              href={BUSINESS.tel}
              data-testid="home-cta-call-link"
              className="inline-flex items-center gap-3 bg-gold px-8 py-4 text-sm font-medium uppercase tracking-[0.15em] text-obsidian transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_36px_rgba(212,175,55,0.35)]"
            >
              <Phone className="h-4 w-4" strokeWidth={1.5} />
              {t.homeCta.call}
            </a>
            <a
              href={BUSINESS.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="home-cta-whatsapp-link"
              className="inline-flex items-center gap-3 border border-gold/50 px-8 py-4 text-sm font-medium uppercase tracking-[0.15em] text-gold transition-all duration-300 hover:border-gold hover:bg-gold/10"
            >
              <WhatsAppIcon className="h-4 w-4" />
              {t.homeCta.whatsapp}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
